/* eslint-disable camelcase */
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class HubspotService extends AbstractService {
	static hubSpotApi = NexusService.hubSpotApi;

	static searchCompanies(query, after) {
		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "POST",
				RelativePath: "companies/search",
				QueryParams: "archived=false",
				Data: JSON.stringify({ query, after }),
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}

	static searchContactsByEmail(email) {
		const data = {
			filters: [
				{
					propertyName: "email",
					operator: "EQ",
					value: email,
				},
			],
			properties: ["contact_type", "officer_id", "firstname", "lastname", "email"],
		};

		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "POST",
				RelativePath: "contacts/search",
				QueryParams: "archived=false",
				Data: JSON.stringify(data),
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}

	static getContactDetails(contactId, query) {
		const queryParams = query === "officer-properties" ? undefined : query;
		const officerQS =
			query === "officer-properties"
				? "?properties=contact_type&properties=officer_id&properties=firstname&properties=lastname&properties=email"
				: "";

		const formattedQueryParams = queryParams === undefined ? "" : query;

		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "GET",
				RelativePath: `contacts/${contactId}${officerQS}`,
				QueryParams: formattedQueryParams,
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}

	static createContact(firstname, lastname, email, contact_type, officer_id) {
		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "POST",
				RelativePath: "contacts",
				Data: JSON.stringify({
					properties: {
						firstname,
						lastname,
						email,
						contact_type,
						officer_id,
					},
				}),
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}

	static updateContactProperties(contactId, properties) {
		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "PATCH",
				RelativePath: `contacts/${contactId}`,
				Data: JSON.stringify({properties}),
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}

	static syncCompanyToContact(companyId, contactId) {
		const params = {
			hubSpotRemoteCallPayload: {
				HttpMethod: "PUT",
				RelativePath: `companies/${companyId}/associations/contact/${contactId}/company_to_contact`,
				Data: "",
			},
		};

		return this.hubSpotApi
			.sendHubSpotRequest(params)
			.then(response => ({ data: JSON.parse(response.Data) }));
	}
}
